import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IndicesSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getIndicesSearch(data);
    }
}
export default IndicesSearchUseCase;
